import { createGesture } from '@ionic/vue'

export default {
  mounted(el) {
    let moved = false

    const onPointerDown = (e) => {
      moved = false
    }

    const onPointerMove = (e) => {
      moved = true
    }

    const onClick = (e) => {
      if (moved) {
        e.stopImmediatePropagation()
        e.preventDefault()
      }
    }

    el.addEventListener('pointerdown', onPointerDown)
    el.addEventListener('pointermove', onPointerMove)
    el.addEventListener('click', onClick, true) // Capture phase to cancel early


    const gesture = createGesture({
      el,
      threshold: 20,
      gestureName: 'disable-goback',
      gesturePriority: 41.0,
      onEnd: () => {}
    })
    gesture.enable(true)
    el._gestureCleanup = () => {
      gesture.destroy()
      el.removeEventListener('pointerdown', onPointerDown)
      el.removeEventListener('pointermove', onPointerMove)
      el.removeEventListener('click', onClick, true)
    }
  },
  unmounted(el) {
    el._gestureCleanup()
  }
}

